import React, { useState, useEffect } from "react";
import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import labels from "../../constants/SmsTemplate";
import configuration from '../../config';
import { toast } from 'react-toastify';
import UND from 'underscore'

// Add SMS Template
function Add({ history }) {
  const [fieldArr, setFieldArr] = useState([])
  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({});
  const [languages, setLanguages] = useState([])

  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];
  const isSendOpt = [
    { id: 1, title: "Yes", value: "true" },
    { id: 2, title: "No", value: "false" },];
  const columnArr = [
    { id: 0, title: "Title", name: "title", type: "TextInput" },
    { id: 1, title: "Code", name: "template_code", type: "TextInput" },
    { id: 3, title: "Status", name: "status", type: "Dropdown", options: statusOpt },
  ];


  useEffect(() => {
    getlanguages();
  }, []);

  function getlanguages() {
    configuration.getAPI({ url: 'language/list', params: { status: 'active' } }).then((data) => {
      if (data.status === 200) {
        setLanguages(data.payload)
        let valueArr = []
        let captionValueArr = []
        UND.each(data.payload, (lang, ind) => {
          valueArr.push({ id: ind, title: "Value[" + lang.title + "]", name: "value_" + lang.code, type: "TextInput" })
          captionValueArr.push({ id: ind, title: "Caption Value[" + lang.title + "]", name: "caption_value_" + lang.code, type: "TextInput" })
        })
        const fullCoulnmArr = columnArr.concat(valueArr, captionValueArr);
        setFieldArr(fullCoulnmArr)
      }
    }).catch(error => {
      return toast.error(error.message)
    });
  }

  function handleValidation() {
    let flag = true;
    let error = {}
    if (!fields.title) {
      error['title'] = "Please enter sms title"
      flag = false
    }

    if (!fields.template_code) {
      error['template_code'] = "Please enter template code "
      flag = false
    }
    if (!fields.status) {
      error['status'] = "Please select status"
      flag = false
    }

    UND.each(languages, (lang, ind) => {
      if (!fields['value_' + lang.code]) {
        error['value_' + lang.code] = "Please enter value in " + lang.title
        flag = false
      }
      if (!fields['value_' + lang.code]) {
        error['caption_value_' + lang.code] = "Please enter caption value in " + lang.title
        flag = false
      }
    })

    setErrors({ ...error })
    return flag;
  }

  const handleSubmit = () => {
    if (handleValidation()) {
      configuration.postAPI({ url: 'sms-template/create', params: fields }).then((data) => {
        if (data.status === 200) {
          history.push('/sms-template')
        } else if (data.status === 404) {
          return toast.error(data.error.message)
        } else {
          return toast.error('Something went wrong')
        }
      }).catch(error => {
        return toast.error(error.message)
      });
    }
  }

  function handleChange(field, e) {
    setFields({ ...fields, [field]: e.target.value })
  }

  return (
    <>
      <Breadcrumb module={labels.smsTemplate} />
      <AddEditSection
        title="Add Sms Template"
        path="/sms-template"
        fields={fieldArr}
        fieldError={errors}
        fieldValue={fields}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Add;
